import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import Close from "@engineering/icons/close";
import { ClientOnlyPortal } from "./ClientOnlyPortal";
import { ForegroundLayerWrapper, CloseButton } from "./ForegroundLayer.styles";
var ForegroundLayer = function(param) {
    var id = param.id, isShowing = param.isShowing, children = param.children, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {
        return null;
    } : _onClose;
    return isShowing ? /*#__PURE__*/ _jsx(ClientOnlyPortal, {
        selector: "#fglayer",
        children: /*#__PURE__*/ _jsxs(ForegroundLayerWrapper, {
            id: id,
            children: [
                /*#__PURE__*/ _jsx(CloseButton, {
                    id: "".concat(id ? "".concat(id, "-close-button") : ""),
                    icon: Close,
                    title: "close" // @TODO: Add translation
                    ,
                    onClick: onClose
                }),
                children
            ]
        })
    }) : null;
};
export { ForegroundLayer };
